import React, { useEffect, useRef } from "react";
import vid from "../vid/stunnerave.mp4";

export default function Carousel() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      // Ensure the video is muted before playing
      videoRef.current.muted = true;
      videoRef.current.play().catch((error) => {
        console.log("Autoplay prevented:", error);
        // Optionally, you can handle the error by showing a play button or some fallback UI
      });
    }
  }, []);
  return (
    <>
      {/* Fixed video container - stays fixed until content covers it */}
      <div className="fixed top-0 left-0 w-full h-screen z-30">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          src={vid}
          className="object-cover h-full w-full fixed-video"
          onTimeUpdate={(e) => {
            // Sync all videos to this one
            const maskedVideo = document.querySelector(".masked-video");
            if (
              maskedVideo &&
              Math.abs(maskedVideo.currentTime - e.target.currentTime) > 0.1
            ) {
              maskedVideo.currentTime = e.target.currentTime;
            }
          }}
        ></video>
      </div>
    </>
  );
}
